import { useGetMediaFoldersQuery } from "@api/media-folders";
import { ScrollArea } from "@components/ui/scroll-area";
import { MediaLibCategoryEnum } from "@editor/modules/media-lib";
import { type Dispatch, type SetStateAction, useMemo } from "react";
import { MediaLibFileMoveDialogFolder } from "./media-lib-file-move-dialog-folder";

interface IProps {
  showAllFiles?: boolean;
  selectedFolderId: string | null;
  setSelectedFolderId: Dispatch<SetStateAction<string | null>>;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
}

export const MediaLibFileMoveDialogFolders = ({
  showAllFiles,
  selectedFolderId,
  setSelectedFolderId,
  setIsOpen,
}: IProps) => {
  const { data: allFolders = [] } = useGetMediaFoldersQuery({
    archived: false,
  });

  const handleSelect = (id: string | null) => {
    setSelectedFolderId(id);
    setIsOpen(false);
  };

  const topFolders = useMemo(() => {
    return allFolders.filter((folder) => !folder.parentId);
  }, [allFolders]);

  return (
    <ScrollArea maxHeight={248}>
      <div className="tw-p-2">
        {showAllFiles && (
          <MediaLibFileMoveDialogFolder
            title={"All files"}
            folderId={MediaLibCategoryEnum.AllFiles}
            selectedFolderId={selectedFolderId}
            setSelectedFolderId={handleSelect}
          />
        )}
        <MediaLibFileMoveDialogFolder
          title={"Brand assets"}
          folderId={MediaLibCategoryEnum.BrandAssets}
          selectedFolderId={selectedFolderId}
          setSelectedFolderId={handleSelect}
        />
        {topFolders.map((f) => (
          <MediaLibFileMoveDialogFolder
            key={f._id}
            title={f.title}
            folderId={f._id}
            selectedFolderId={selectedFolderId}
            setSelectedFolderId={handleSelect}
          />
        ))}
      </div>
    </ScrollArea>
  );
};
